import style from './testymony.module.css'
import React from 'react'
import icons from '../../../../img/icons/icons'

interface ITestymony {
    name: string;
    text: string;
    pictureUrl?: string;
}

export const Testymony: React.FC<ITestymony> = (props) => {

    return (
        <div className={style.Content}>
            <div className={style.QuoteLeft}>
                <img className={style.QuoteLeftImg} src={icons.reticencia_left} alt="" />
                <img className={style.QuoteLeftImg} src={icons.reticencia_left} alt="" />

            </div>
            <div className={style.ImgArea}>
                <img src={props.pictureUrl || icons.profissional} alt="" />
            </div>

            <div className={style.TextArea}>
                <p>{props.text}</p>
            </div>
            <div className={style.QuoteRight}>
                <img className={style.QuoteRightImg} src={icons.reticencia_rigth} alt="" />
                <img className={style.QuoteRightImg} src={icons.reticencia_rigth} alt="" />
            </div>
            <div className={style.NomedoAluno}>
                <p>{props.name}</p>
            </div>

        </div>
    )
}